<template>
    <div class="border-round border-1 surface-border p-4 surface-card">
        <div class="flex justify-content-between mb-3">
            <Skeleton width="10rem" height="2rem"></Skeleton>
            <Skeleton width="4rem" height="2rem"></Skeleton>
        </div>
        <div class="flex flex-column mb-3">
            <div class="col-12">
                <Skeleton width="100%" height="25px"></Skeleton>
            </div>
            <div class="col-6 flex justify-content-start">
                <Skeleton width="100%" height="25px"></Skeleton>
            </div>
            <div class="col-12 flex justify-content-between gap-5">
                <Skeleton width="100%" height="25px"></Skeleton>
                <Skeleton width="100%" height="25px"></Skeleton>
            </div>

            <div class="font-bold text-center">Please Wait...</div>
            <div class="flex justify-content-center my-2">
                <PulseLoader />
            </div>
            <div class="col-12 flex justify-content-between gap-5">
                <Skeleton width="100%" height="25px"></Skeleton>
                <Skeleton width="100%" height="25px"></Skeleton>
            </div>
            <div class="col-12 flex flex-column gap-5">
                <Skeleton width="100%" height="25px"></Skeleton>
                <Skeleton width="100%" height="25px"></Skeleton>
            </div>
            <div class="col-12 flex justify-content-between gap-5">
                <Skeleton width="100%" height="25px"></Skeleton>
                <Skeleton width="100%" height="25px"></Skeleton>
            </div>
            <div class="col-12 flex justify-content-between gap-5">
                <Skeleton width="100%" height="25px"></Skeleton>
                <Skeleton width="100%" height="25px"></Skeleton>
                <Skeleton width="100%" height="25px"></Skeleton>
            </div>
        </div>
    </div>
</template>

<script setup></script>
